import styled from 'styled-components';
import { claimStatusIds } from 'types/Claims';

interface Props {
	status: claimStatusIds;
}

export const StatusIcon = styled.span<Props>`
	height: 8px;
	width: 8px;
	background-color: ${props => {
		switch (props.status) {
			case 1:
			case 13:
			case 16:
			case 17:
			case 18:
			case 19:
				return '#B4B4B4';
			case 3:
			case 10:
			case 11:
			case 12:
				return '#E0A93E';
			case 4:
			case 5:
			case 9:
				return '#55A63A';
			case 7:
			case 8:
			case 14:
			case 15:
				return '#902727';
		}
	}};
	border-radius: 50%;
	display: inline-block;
	margin-right: 10px;
`;
